
    /* eslint-disable */
    // @ts-nocheck
    // @ts-ignore
    var __STORY__ = "import React from 'react';\nimport { styled, css } from '@storybook/theming';\n\nimport { Icons } from './icon';\nimport { icons, IconKey } from './icons';\n\nconst Meta = styled.div`\n  color: #666;\n  font-size: 12px;\n`;\n\nconst Item = styled.li<{ minimal?: boolean }>`\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  flex: 0 1 16%;\n  min-width: 120px;\n  margin: 16px;\n\n  svg {\n    margin-right: 6px;\n    width: 14px;\n    height: 14px;\n  }\n\n  ${(props) =>\n    props.minimal &&\n    css`\n      flex: none;\n      min-width: auto;\n      padding: 0;\n      margin: 16px;\n\n      svg {\n        display: block;\n        margin-right: 0;\n        width: 14px;\n        height: 14px;\n      }\n    `};\n`;\n\nconst List = styled.ul`\n  display: flex;\n  flex-flow: row wrap;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n`;\n\nconst Header = styled.h2`\n  font-size: 16px;\n  margin: 16px;\n`;\n\nexport default {\n  title: 'Basics/Icon',\n  component: Icons,\n};\n\nexport const Basic = (args) => <Icons {...args} />;\nBasic.args = { icon: 'watch' };\n\nexport const Labels = () => (\n  <>\n    <Header>{Object.keys(icons).length} icons</Header>\n    <List>\n      {Object.keys(icons).map((key) => (\n        <Item key={key}>\n          <Icons icon={key as IconKey} aria-hidden />\n          <Meta>{key}</Meta>\n        </Item>\n      ))}\n    </List>\n  </>\n);\n\nexport const NoLabels = () => (\n  <>\n    <Header>{Object.keys(icons).length} icons</Header>\n    <List>\n      {Object.keys(icons).map((key) => (\n        <Item minimal key={key}>\n          <Icons icon={key as IconKey} aria-label={key} />\n        </Item>\n      ))}\n    </List>\n  </>\n);\n";
    // @ts-ignore
    var __LOCATIONS_MAP__ = {"Basic":{"startLoc":{"col":21,"line":61},"endLoc":{"col":50,"line":61},"startBody":{"col":21,"line":61},"endBody":{"col":50,"line":61}},"Labels":{"startLoc":{"col":22,"line":64},"endLoc":{"col":1,"line":76},"startBody":{"col":22,"line":64},"endBody":{"col":1,"line":76}},"NoLabels":{"startLoc":{"col":24,"line":78},"endLoc":{"col":1,"line":89},"startBody":{"col":24,"line":78},"endBody":{"col":1,"line":89}}};
    
import React from 'react';
import { styled, css } from '@storybook/theming';

import { Icons } from './icon';
import { icons, IconKey } from './icons';

const Meta = styled.div`
  color: #666;
  font-size: 12px;
`;

const Item = styled.li<{ minimal?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  flex: 0 1 16%;
  min-width: 120px;
  margin: 16px;

  svg {
    margin-right: 6px;
    width: 14px;
    height: 14px;
  }

  ${(props) =>
    props.minimal &&
    css`
      flex: none;
      min-width: auto;
      padding: 0;
      margin: 16px;

      svg {
        display: block;
        margin-right: 0;
        width: 14px;
        height: 14px;
      }
    `};
`;

const List = styled.ul`
  display: flex;
  flex-flow: row wrap;
  list-style: none;
  padding: 0;
  margin: 0;
`;

const Header = styled.h2`
  font-size: 16px;
  margin: 16px;
`;

export default {parameters: {"storySource":{"source":"import React from 'react';\nimport { styled, css } from '@storybook/theming';\n\nimport { Icons } from './icon';\nimport { icons, IconKey } from './icons';\n\nconst Meta = styled.div`\n  color: #666;\n  font-size: 12px;\n`;\n\nconst Item = styled.li<{ minimal?: boolean }>`\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  flex: 0 1 16%;\n  min-width: 120px;\n  margin: 16px;\n\n  svg {\n    margin-right: 6px;\n    width: 14px;\n    height: 14px;\n  }\n\n  ${(props) =>\n    props.minimal &&\n    css`\n      flex: none;\n      min-width: auto;\n      padding: 0;\n      margin: 16px;\n\n      svg {\n        display: block;\n        margin-right: 0;\n        width: 14px;\n        height: 14px;\n      }\n    `};\n`;\n\nconst List = styled.ul`\n  display: flex;\n  flex-flow: row wrap;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n`;\n\nconst Header = styled.h2`\n  font-size: 16px;\n  margin: 16px;\n`;\n\nexport default {\n  title: 'Basics/Icon',\n  component: Icons,\n};\n\nexport const Basic = (args) => <Icons {...args} />;\nBasic.args = { icon: 'watch' };\n\nexport const Labels = () => (\n  <>\n    <Header>{Object.keys(icons).length} icons</Header>\n    <List>\n      {Object.keys(icons).map((key) => (\n        <Item key={key}>\n          <Icons icon={key as IconKey} aria-hidden />\n          <Meta>{key}</Meta>\n        </Item>\n      ))}\n    </List>\n  </>\n);\n\nexport const NoLabels = () => (\n  <>\n    <Header>{Object.keys(icons).length} icons</Header>\n    <List>\n      {Object.keys(icons).map((key) => (\n        <Item minimal key={key}>\n          <Icons icon={key as IconKey} aria-label={key} />\n        </Item>\n      ))}\n    </List>\n  </>\n);\n","locationsMap":{"basic":{"startLoc":{"col":21,"line":61},"endLoc":{"col":50,"line":61},"startBody":{"col":21,"line":61},"endBody":{"col":50,"line":61}},"labels":{"startLoc":{"col":22,"line":64},"endLoc":{"col":1,"line":76},"startBody":{"col":22,"line":64},"endBody":{"col":1,"line":76}},"no-labels":{"startLoc":{"col":24,"line":78},"endLoc":{"col":1,"line":89},"startBody":{"col":24,"line":78},"endBody":{"col":1,"line":89}}}},},
  title: 'Basics/Icon',
  component: Icons,
};

export const Basic = (args) => <Icons {...args} />;;
Basic.args = { icon: 'watch' };

export const Labels = () => (
  <>
    <Header>{Object.keys(icons).length} icons</Header>
    <List>
      {Object.keys(icons).map((key) => (
        <Item key={key}>
          <Icons icon={key as IconKey} aria-hidden />
          <Meta>{key}</Meta>
        </Item>
      ))}
    </List>
  </>
);;

export const NoLabels = () => (
  <>
    <Header>{Object.keys(icons).length} icons</Header>
    <List>
      {Object.keys(icons).map((key) => (
        <Item minimal key={key}>
          <Icons icon={key as IconKey} aria-label={key} />
        </Item>
      ))}
    </List>
  </>
);
